export const NEW_ACCOUNT_VALUE = 'new';
export const PLACEHOLDER_ACCOUNT_VALUE = 'placeholder';
export const ALL_ACCOUNTS_VALUE = 'all';
export const MAIN_ACCOUNT_TYPE = 'MAIN';
